import { PhoneCall } from "lucide-react";
import { cn } from "@/lib/cn";
import { useUiStore } from "@/store";

type FloatingDialerButtonProps = {
  className?: string;
};

/** Renders in the main body panel (not the rail / list subsidebar). Parent must be `relative`. */
export function FloatingDialerButton({ className }: FloatingDialerButtonProps) {
  const openDialer = useUiStore((state) => state.openDialer);
  const dialerOpen = useUiStore((state) => state.dialerOpen);

  if (dialerOpen) return null;

  return (
    <button
      type="button"
      title="Open Assist Phone"
      aria-label="Open Assist Phone"
      onClick={openDialer}
      className={cn(
        "absolute bottom-5 left-5 z-[70] inline-flex h-14 w-14 items-center justify-center rounded-full",
        "bg-papaya-deep text-white shadow-[0_12px_28px_rgba(235,94,40,0.4)]",
        "transition-transform hover:scale-[1.04] hover:bg-papaya-deep/90 active:scale-[0.98]",
        className,
      )}
    >
      <PhoneCall className="h-6 w-6" strokeWidth={2.1} />
    </button>
  );
}
